import type { InsightsDashboardPoolState } from '@aytm/app/insights/dashboard/duckness/ducks/types'
import type { TrackAttributesModel, TrackTargetType } from '@aytm/app/insights/dashboard/models/types.ClientDTO'

import { getCurrentBlock, updateCurrentBlock } from './requests'
import { updateHiddenItems } from './items'

export type TrackTargetChangePayload = {
  trackTarget: TrackTargetType
}

export type TrackAttributesChangePayload = {
  trackAttributes: TrackAttributesModel
}

export type CurrentSplitChangePayload = {
  currentSplit: string
}

export type SwapChangePayload = {
  swap: boolean
}

export type WaveChangePayload = {
  wave: string
}

/**
 * Change current data source
 */
export const trackTargetChange = (
  state: InsightsDashboardPoolState,
  { trackTarget }: TrackTargetChangePayload
): InsightsDashboardPoolState => {
  let resultState = updateCurrentBlock(state, { trackTarget })
  const block = getCurrentBlock(resultState)
  const trackAttributes = block?.getJS<'trackAttributes'>('trackAttributes')
  const attributes = resultState.currentData?.attributes || {}
  if ('attribute' === trackTarget && !trackAttributes?.[trackTarget]) {
    const attribute = Object.values(attributes)?.find(v => !v.meta)?.key
    if (attribute) {
      resultState = updateCurrentBlock(resultState, {
        trackAttributes: { ...trackAttributes, attribute }
      })
    }
  }
  return resultState
}

/**
 * Track attributes change
 */
export const trackAttributesChange = (
  state: InsightsDashboardPoolState,
  { trackAttributes }: TrackAttributesChangePayload
): InsightsDashboardPoolState => updateCurrentBlock(state, { trackAttributes })

/**
 * Change current split
 */
export const currentSplitChange = (
  state: InsightsDashboardPoolState,
  { currentSplit }: CurrentSplitChangePayload
): InsightsDashboardPoolState => {
  let resultState = updateCurrentBlock(state, { currentSplit, showRowAverages: false })
  resultState = updateHiddenItems(resultState, {})
  return resultState
}

/**
 * Change current split
 */
export const swapChange = (
  state: InsightsDashboardPoolState,
  { swap }: SwapChangePayload
): InsightsDashboardPoolState => updateCurrentBlock(state, { swap })

/**
 * Change current wave interval
 */
export const waveChange = (
  state: InsightsDashboardPoolState,
  { wave }: WaveChangePayload
): InsightsDashboardPoolState => updateCurrentBlock(state, { currentWave: wave, currentPreset: 'All' })
